import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { AdminService } from '../../../admin.service';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { FormGroup, Validators, FormControl } from '@angular/forms';

import { QuickDesignService } from '../../../../services/quick-deisgn.service';
import { QuickDesign } from '../../../../models/quick-design.model';
import { GroupService } from '../../../../services/group.service';
import { DepartmentService } from '../../../../services/department.service';
import { MediaAttributeService } from '../../../../services/media-attribute.service';
import { Subscription } from 'rxjs/Subscription';
import { Group } from '../../../../models/group.model';
import { MediaAttribute } from '../../../../models/media-attribute.model';
import { Department } from '../../../../models/department.model';

import { Select2OptionData } from 'ng2-select2';
import { Client } from '../../../../models/client.model';
import { ClientService } from '../../../../services/client.service';

@Component({
  selector: 'app-quick-design-edit',
  templateUrl: './quick-design-edit.component.html',
  styleUrls: ['./quick-design-edit.component.css']
})
export class QuickDesignEditComponent implements OnInit, OnDestroy {
  loading = false;
  id: number;
  editMode = false;
  backUrl: string;
  category: string;

  category_id: number;

  subscription: Subscription;
  subscriptionGroup: Subscription;
  subscriptionMediaAttribute: Subscription;
  subscriptionDepartment: Subscription;
  subscriptionClient: Subscription;
  subscriptionResponse: Subscription;

  categories = {
    'enewsletter': 1,
    'buyer-match': 2,
    'quick-enquiry': 3,
    'brochure': 4,
    'property-guide': 5,
    'social-media': 6,
    'email-signature': 7,
    'dl-card': 8,
    'sign-board': 9
  };

  quickDesign: QuickDesign;
  quickDesignForm: FormGroup;

  groups: Group[];
  mediaAttributes: MediaAttribute[];
  departments: Department[];
  clients: Client[];

  s2ClientValue = 0;
  s2ClientData: Array<Select2OptionData>;
  s2ClientOptions: Select2Options;

  quickDesign_title = '';

  @ViewChild('fileIcon') fileIcon: ElementRef;

  constructor(private quickDesignService: QuickDesignService,
              private groupService: GroupService,
              private mediaAttributeService: MediaAttributeService,
              private departmentService: DepartmentService,
              private clientService: ClientService,
              private route: ActivatedRoute,
              private router: Router) { }

  ngOnInit() {

    this.route.params.subscribe(
      (params: Params) => {
        this.id = +params['id'];
        this.editMode = params['id'] != null;
        this.backUrl = this.editMode ? '../../' : '../';
        this.category = params['type'];
        this.category_id = this.categories[this.category];

        if (this.id) {
          this.loading = true;
          this.quickDesignService.httpGetQuickDesign(this.id);
        }
      }
    );

    this.groupService.httpGetGroups();
    this.mediaAttributeService.httpGetMediaAttributes();
    this.departmentService.httpGetDepartments();
    this.clientService.httpGetClients({}, 'list');

    this.subscriptionGroup = this.groupService.groupsChanged.subscribe(
      (groups: Group[]) => {
        this.groups = groups;
      }
    );

    this.subscriptionMediaAttribute = this.mediaAttributeService.mediaAttributesChanged.subscribe(
      (mediaAttributes: MediaAttribute[]) => {
        this.mediaAttributes = mediaAttributes;
      }
    );

    this.subscriptionDepartment = this.departmentService.departmentsChanged.subscribe(
      (departments: Department[]) => {
        this.departments = departments;
      }
    );

    this.subscriptionClient = this.clientService.clientsChanged.subscribe(
      (clients: Client[]) => {
        if (typeof clients !== 'undefined' && clients.length > 0) {
          this.s2ClientData =  <any>clients.map(
            (obj) => {
              return {id: obj.ID, text:  (obj.name ? obj.name : obj.company_name) + ' (' + obj.office_id + ')'};
            }
          );
          this.s2ClientData.unshift({id: '0', text: 'All'});
        }

        if ( this.editMode && typeof this.quickDesign.ID !== 'undefined' ) {
          this.loading = false;

          this.initFormEdit();
        }
      }
    );

    this.s2ClientOptions = {
      width: '100%',
      placeholder: 'Select a Client'
    };

    this.subscription = this.quickDesignService.quickDesignChanged.subscribe(
      (quickDesign: QuickDesign) => {
        this.quickDesign = quickDesign;

        if ( this.editMode && typeof quickDesign !== 'undefined' ) {
          // this.initFormEdit();
        }
      }
    );

    this.subscriptionResponse = this.quickDesignService.quickDesignOperation.subscribe(
      (quickDesign: QuickDesign) => {
        if ( typeof quickDesign.ID !== 'undefined' ) {
          this.loading = false;
          this.router.navigate([this.backUrl], {relativeTo: this.route});
        }
      }
    );

    this.initForm();
  }

  private initForm() {
    this.quickDesignForm = new FormGroup({
      'title': new FormControl('', Validators.required),
      'description': new FormControl(''),
      'provider': new FormControl('all', Validators.required),
      'group_id': new FormControl(1, Validators.required),
      'media_attribute_id': new FormControl(1, Validators.required),
      'department_id': new FormControl(1, Validators.required),
      'client_id': new FormControl(this.s2ClientValue, Validators.required),
      'is_active': new FormControl(1, Validators.required),
      'icon': new FormControl('')
    });
  }

  private initFormEdit() {
    this.s2ClientValue = this.quickDesign.client_id;
    this.quickDesign_title = this.quickDesign.title;
    this.quickDesignForm.patchValue({
      'title': this.quickDesign.title,
      'description': this.quickDesign.description,
      'provider': this.quickDesign.provider,
      'group_id': this.quickDesign.group_id,
      'media_attribute_id': this.quickDesign.media_attribute_id,
      'department_id': this.quickDesign.department_id,
      'client_id': this.s2ClientValue,
      'is_active': this.quickDesign.is_active,
      'icon': this.quickDesign.icon
    });
  }

  patchForm(field, value) {
    if (field === 'client_id') {
      this.quickDesignForm.patchValue({'client_id': value});
      this.s2ClientValue = value;
    }

  }

  onSubmit() {
    const quickDesignValues = this.quickDesignForm.value;

    const icon = this.fileIcon.nativeElement;
    this.loading = true;

    if (icon.files.length > 0) {
      quickDesignValues['iconFile'] = icon.files[0];
    }

    if ( this.editMode) {
      this.quickDesignService.httpPutQuickDesign(this.id, quickDesignValues);
    } else {
      quickDesignValues['category_id'] = this.category_id;

      this.quickDesignService.httpPostQuickDesign(quickDesignValues);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptionGroup.unsubscribe();
    this.subscriptionMediaAttribute.unsubscribe();
    this.subscriptionDepartment.unsubscribe();
    this.subscriptionResponse.unsubscribe();
    this.subscriptionClient.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/templates/quick-designs/quick-design-edit/quick-design-edit.component.ts